import React, { useState, useRef, useEffect, useCallback } from "react";
import { MoreVert } from "@mui/icons-material";

const ModuleActionsMenu = ({ module, onView, onEdit, onActivate, onDelete, onGenerateAI }) => {
    const [showMenu, setShowMenu] = useState(false);
    const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
    const buttonRef = useRef(null);
    const menuRef = useRef(null);

    const calculateMenuPosition = useCallback(() => {
        if (buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            const menuWidth = 160;

            const top = rect.bottom + 8;
            let left = rect.right - menuWidth;

            if (left < 8) {
                left = rect.left;
            } else if (rect.right > window.innerWidth - 8) {
                left = window.innerWidth - menuWidth - 8;
            }

            setMenuPosition({ top, left });
        }
    }, []);

    useEffect(() => {
        if (!showMenu) return;

        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target) &&
                buttonRef.current && !buttonRef.current.contains(event.target)) {
                setShowMenu(false);
            }
        };

        const handleResize = () => {
            calculateMenuPosition();
        };

        calculateMenuPosition();

        document.addEventListener('mousedown', handleClickOutside);
        window.addEventListener('scroll', handleResize, true);
        window.addEventListener('resize', handleResize);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            window.removeEventListener('scroll', handleResize, true);
            window.removeEventListener('resize', handleResize);
        };
    }, [showMenu, calculateMenuPosition]);

    const handleButtonClick = (e) => {
        e.stopPropagation();
        if (!showMenu) {
            if (buttonRef.current) {
                const rect = buttonRef.current.getBoundingClientRect();
                const menuWidth = 160;
                const top = rect.bottom + 8;
                let left = rect.right - menuWidth;

                if (left < 8) {
                    left = rect.left;
                } else if (rect.right > window.innerWidth - 8) {
                    left = window.innerWidth - menuWidth - 8;
                }

                setMenuPosition({ top, left });
            }
            setShowMenu(true);
        } else {
            setShowMenu(false);
        }
    };

    const handleView = (e) => {
        e.stopPropagation();
        onView(module);
        setShowMenu(false);
    };

    const handleEdit = (e) => {
        e.stopPropagation();
        onEdit(module);
        setShowMenu(false);
    };

    const handleActivate = (e) => {
        e.stopPropagation();
        onActivate(module);
        setShowMenu(false);
    };

    const handleDelete = (e) => {
        e.stopPropagation();
        onDelete(module);
        setShowMenu(false);
    };

    const handleGenerateAI = (e) => {
        e.stopPropagation();
        if (onGenerateAI) onGenerateAI(module);
        setShowMenu(false);
    };

    return (
        <div className="modules-actions-container pr">
            <button
                ref={buttonRef}
                onClick={handleButtonClick}
                className="modules-actions-btn df jcc aic cp"
                data-tooltip="Actions"
            >
                <MoreVert style={{ fontSize: '20px', color: '#666' }} />
            </button>
            {showMenu && (
                <>
                    <div
                        className="modules-actions-backdrop"
                        onClick={() => setShowMenu(false)}
                    />
                    <div
                        ref={menuRef}
                        className="modules-actions-menu zi100"
                        style={{
                            top: `${menuPosition.top - 30}px`,
                            left: `${menuPosition.left - 30}px`
                        }}
                    >
                        <button
                            onClick={handleView}
                            className="modules-action-item"
                        >
                            <i className="fa fa-eye mr0-5rem" /> View
                        </button>
                        <button
                            onClick={handleEdit}
                            className="modules-action-item"
                        >
                            <i className="fa fa-pencil mr0-5rem" /> Edit
                        </button>
                        {/* <button
                            onClick={handleActivate}
                            className="modules-action-item"
                        >
                            <i className="fa fa-power-off mr0-5rem" />
                            {module['isActive'] ? 'Deactivate' : 'Activate'}
                        </button> */}
                        <button
                            onClick={handleDelete}
                            className="modules-action-item modules-action-danger"
                        >
                            <i className="fa fa-trash mr0-5rem" /> Delete
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default ModuleActionsMenu;

